(function(){
  let globalInitialized = false;
  let lastScrollHandler = null;

  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once:true });
    else fn();
  }

  function initIntro(){
    const intro = document.getElementById('intro');
    if(!intro) return;
    if(window.Shopify && window.Shopify.designMode){
      setTimeout(()=>intro.classList.add('done'), 650);
    } else {
      setTimeout(()=>intro.classList.add('done'), 2100);
    }
  }

  function initMenu(){
    const nav = document.getElementById('nav');
    const menu = document.getElementById('menu');
    const toggle = document.getElementById('toggle');
    if(!nav || !menu || !toggle || toggle.dataset.thaliaBound === 'true') return;
    toggle.dataset.thaliaBound = 'true';
    toggle.addEventListener('click',()=>{ nav.classList.toggle('open'); menu.classList.toggle('open'); });
    document.querySelectorAll('[data-close]').forEach(a=>{
      if(a.dataset.thaliaBound === 'true') return;
      a.dataset.thaliaBound = 'true';
      a.addEventListener('click',()=>{ nav.classList.remove('open'); menu.classList.remove('open'); });
    });
  }

  function initScrollEffects(){
    if(lastScrollHandler) window.removeEventListener('scroll', lastScrollHandler);
    const prog = document.getElementById('progress');
    const cI = document.querySelector('.cover__img');
    const shots = [...document.querySelectorAll('.shot__img')];
    lastScrollHandler = function(){
      const h = document.documentElement;
      if(prog){
        const denom = Math.max(1, h.scrollHeight - h.clientHeight);
        prog.style.width = (h.scrollTop / denom * 100) + '%';
      }
      if(cI) cI.style.transform = `translateY(${scrollY*0.25}px) scale(1.08)`;
      shots.forEach(s=>{
        if(!s.parentElement) return;
        const r = s.parentElement.getBoundingClientRect();
        const off = (r.top + r.height/2 - innerHeight/2) / innerHeight;
        s.style.transform = `translateY(${off*-40}px) scale(1.12)`;
      });
    };
    window.addEventListener('scroll', lastScrollHandler, { passive:true });
    lastScrollHandler();
  }

  function initReveal(root=document){
    const els = root.querySelectorAll ? root.querySelectorAll('.reveal') : [];
    if(!('IntersectionObserver' in window)){
      els.forEach(el=>el.classList.add('in'));
      return;
    }
    const io = new IntersectionObserver(es=>es.forEach(e=>{
      if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
    }), { threshold:.12 });
    els.forEach(el=>{
      if(el.dataset.thaliaReveal === 'true') return;
      el.dataset.thaliaReveal = 'true';
      io.observe(el);
    });
  }

  const EMO = ['🌸','💖','✨','🌷','💕','🤍'];
  function rain(n=30){
    for(let i=0;i<n;i++){
      const p = document.createElement('div');
      p.className='petal';
      p.textContent = EMO[Math.floor(Math.random()*EMO.length)];
      p.style.left = Math.random()*100+'vw';
      const d = 3+Math.random()*3, sz = 14+Math.random()*18;
      p.style.fontSize = sz+'px';
      document.body.appendChild(p);
      const anim = p.animate([
        {transform:'translateY(-40px) rotate(0)',opacity:1},
        {transform:`translateY(110vh) rotate(${Math.random()*720-360}deg)`,opacity:.9}
      ], {duration:d*1000,delay:Math.random()*600,easing:'cubic-bezier(.3,.1,.4,1)'});
      anim.onfinish = ()=>p.remove();
    }
  }

  function initButtons(root=document){
    document.querySelectorAll('[data-thalia-petal-button]').forEach(btn=>{
      if(btn.dataset.thaliaBound === 'true') return;
      btn.dataset.thaliaBound = 'true';
      btn.addEventListener('click',()=>rain(44));
    });

    document.querySelectorAll('[data-thalia-surprise]').forEach(section=>{
      const btn = section.querySelector('[data-thalia-surprise-button]');
      const msg = section.querySelector('[data-thalia-surprise-message]');
      const messageEls = [...section.querySelectorAll('[data-message]')];
      const messages = messageEls.map(el => el.getAttribute('data-message')).filter(Boolean);
      if(!btn || !msg || btn.dataset.thaliaBound === 'true') return;
      btn.dataset.thaliaBound = 'true';
      let mi = -1;
      btn.addEventListener('click',()=>{
        if(!messages.length) return;
        mi = (mi + 1) % messages.length;
        msg.classList.remove('show');
        setTimeout(()=>{ msg.textContent = messages[mi]; msg.classList.add('show'); },160);
        rain(12);
      });
    });
  }

  function initAll(root=document){
    initMenu();
    initReveal(root);
    initButtons(root);
    initScrollEffects();
    if(!globalInitialized){ initIntro(); globalInitialized = true; }
  }

  ready(()=>initAll(document));
  window.addEventListener('load', initIntro, { once:true });
  document.addEventListener('shopify:section:load', e=>initAll(e.target));
})();